import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Linkedin, Facebook, Twitter } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0a69b2] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <p className="font-montserrat text-gray-300 text-sm mb-4 leading-relaxed">
              A holistic financial advisory firm serving individuals and families nationwide with comprehensive wealth management solutions.
            </p>
            <div className="flex gap-4">
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-gray-300 transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin size={20} />
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-gray-300 transition-colors"
                aria-label="Facebook"
              >
                <Facebook size={20} />
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-gray-300 transition-colors"
                aria-label="Twitter"
              >
                <Twitter size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bellefair text-lg  mb-4 uppercase">Services</h4>
            <ul className="space-y-2 font-montserrat text-sm">
              <li>
                <Link to="/asset-management" className="text-gray-300 hover:text-white transition-colors">
                  Wealth Management
                </Link>
              </li>
              <li>
                <Link to="/tax" className="text-gray-300 hover:text-white transition-colors">
                  Tax
                </Link>
              </li>
              <li>
                <Link to="/estate" className="text-gray-300 hover:text-white transition-colors">
                  Estate
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-300 hover:text-white transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <a 
                  href="https://www.dropbox.com/request/6EBP1JVtvxJKZakczxyz"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  Share documents with your Advisor
                </a>
              </li>
              <li>
                <a 
                  href="https://www.dropbox.com/request/up3HU2Q9dA7RT8rhTT1V"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  Tax Document Upload
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-bellefair text-lg  mb-4 uppercase">Contact</h4>
            <ul className="space-y-3 font-montserrat text-sm">
              <li className="flex items-start gap-2 text-gray-300">
                <Phone size={16} className="mt-1 flex-shrink-0" />
                <a href="tel:941-545-9057" className="hover:text-white transition-colors">
                  941-545-9057
                </a>
              </li>
              <li className="flex items-start gap-2 text-gray-300">
                <Mail size={16} className="mt-1 flex-shrink-0" />
                <a href="mailto:contact@paracca.com" className="hover:text-white transition-colors">
                  contact@paracca.com
                </a>
              </li>
              <li className="flex items-start gap-2 text-gray-300">
                <MapPin size={16} className="mt-1 flex-shrink-0" />
                <address className="not-italic">
                  428 S Tamiami Trail<br />
                  Osprey, FL 34229
                </address>
              </li>
            </ul>
          </div>

          {/* Service Area */}
          <div>
            <h4 className="font-bellefair text-lg  mb-4 uppercase">Service Area</h4>
            <p className="font-montserrat text-sm text-gray-300 leading-relaxed">
              Proudly serving clients nationwide in all 50 states.
            </p>
            <div className="mt-4">
              <a
                href="https://client.myadvisorlink.com/auth/users/webportal/paracca"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-white text-[#0a69b2] px-6 py-2 rounded font-montserrat font-semibold text-sm hover:bg-gray-100 transition-colors"
              >
                Client Login
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-blue-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center text-sm font-montserrat text-gray-300">
          <p>© {currentYear} Paracca Financial Group. All rights reserved.</p>
          <div className="flex gap-6 mt-4 md:mt-0">
            <Link to="/privacy" className="hover:text-white transition-colors">
              Privacy Policy
            </Link>
            <Link to="/terms" className="hover:text-white transition-colors">
              Terms of Service
            </Link>
            <Link to="/disclosures" className="hover:text-white transition-colors">
              Disclosures
            </Link>
          </div>
        </div>

        {/* Disclaimer */}
        <div className="mt-6 pt-6 border-t border-blue-800">
          <p className="text-xs text-gray-400 font-montserrat leading-relaxed">
            Investment advisory services offered through Paracca Financial Group, a Fiduciary registered investment advisory firm. This website is for informational purposes only and does not constitute financial advice. Past performance does not guarantee future results. Securities and investment advisory services may be subject to regulatory oversight.
          </p>
        </div>

        {/* Copyright */}
        <div className="mt-6 pt-6 border-t border-blue-800">
          <p className="text-xs text-gray-400 font-montserrat text-center">
            © {new Date().getFullYear()} Paracca Financial Group. All rights reserved.
          </p>
          <p className="text-xs text-gray-500 font-montserrat mt-2 text-center">
            Website by{' '}
            <a 
              href="https://emergent.sh" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-gray-400 transition-colors"
            >
              Emergent
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
